// Known documentation tools
export const SPHINX = "sphinx";
export const MKDOCS = "mkdocs";
export const MKDOCS_MATERIAL = "mkdocs-material";
export const ZENSICAL = "zensical";
export const DOCUSAURUS = "docusaurus";
export const MYSTMD = "mystmd";
export const PELICAN = "pelican";
export const ASCIIDOCTOR = "asciidoctor";
export const JEKYLL = "jekyll";
export const DOCSIFY = "docsify";
export const ANTORA = "antora";
export const MDBOOK = "mdbook";
export const VITEPRESS = "vitepress";
export const FALLBACK_DOCTOOL = "fallback";

// Known documentation tools themes
export const SPHINX_ALABASTER = "alabaster";
export const SPHINX_FURO = "furo";
export const SPHINX_READTHEDOCS = "readthedocs";
export const SPHINX_IMMATERIAL = "immaterial";
export const SPHINX_PYDATA = "pydata";
export const SPHINX_PICCOLO = "piccolo";

// API URLs
export const EMBED_API_ENDPOINT = "/_/api/v3/embed/";

// Theme modes
export const THEME_LIGHT_MODE = "light-mode";
export const THEME_DARK_MODE = "dark-mode";
export const THEME_UNKNOWN_MODE = "unknown-mode";
